<div class="cm-entity-metadata" [tp]="EntityChangedTooltipComponent" [tpData]="$data()" tpVariation="light">
    <cm-user-thumbnail [user]="$data()?.createdBy"></cm-user-thumbnail>
    @if ($data()?.createdAt) {
        <span class="cm-date-text">{{ $data()?.createdAt | cmTimeAgo }}</span>
    }
</div>
